//Node Modules
import { useLayoutEffect } from "react";
import { Outlet } from "react-router-dom";
import { ScrollRestoration } from "react-router-dom";
import polyfill from "@oddbird/css-anchor-positioning/fn";
import { useAtomValue } from "jotai";

//My Components
import { AppFooter, AppHeader } from "./components/layout";

//3rd Party Components

//Atoms
import { previewContentAtom } from "./state/appState";

//Helpers

//Styles
import "./assets/css/main.css";
import "bootstrap-icons/font/bootstrap-icons.css";

//Messages
import "./i18n";
import { ApolloWrapper } from "./components/helpers";

const App = () => {
	//Atom State
	const isPreviewContent = useAtomValue(previewContentAtom);

	//On Load
	useLayoutEffect(() => {
		initPolyfill();
	}, []);

	const initPolyfill = () => {
		if (!("anchorName" in document.documentElement.style)) {
			polyfill();
		}
	};

	return (
		<ApolloWrapper>
			<div className="app" data-previewcontent={isPreviewContent}>
				<AppHeader />
				<main>
					<Outlet />
				</main>
				<AppFooter />
				<ScrollRestoration />
			</div>
		</ApolloWrapper>
	);
};

export default App;
